import { dateTime } from '@/_shared';

import type { DeliverableWholesalePriceFormSchema } from './model';

export function validateWholesalePrice(deliverable_wholesale_price: DeliverableWholesalePriceFormSchema[]) {
  if (!deliverable_wholesale_price?.length) {
    return { result: true, index: -1, error: null };
  }

  // Check for overlapping schedules
  for (let i = 0; i <= deliverable_wholesale_price.length - 1; i++) {
    const currentStartDate = deliverable_wholesale_price[i].start_date;
    const currentEndDate = deliverable_wholesale_price[i].end_date;

    if (currentStartDate && currentEndDate) {
      if (dateTime.parse(currentStartDate).isSameOrAfter(dateTime.parse(currentEndDate))) {
        return { result: false, index: i, error: 'Invalid Schedule' };
      }
    }

    const currentDiscount = deliverable_wholesale_price[i];
    const nextDiscount = deliverable_wholesale_price[i + 1];

    // Check if both items have valid dates
    if (currentDiscount?.end_date && nextDiscount?.start_date) {
      const currentEnd = dateTime.parse(currentDiscount.end_date);
      const nextStart = dateTime.parse(nextDiscount.start_date);

      if (currentEnd.isSameOrAfter(nextStart)) {
        return { result: false, index: i + 1, error: 'Overlapping schedule' };
      }
    }
  }

  return { result: true, index: -1, error: null };
}
